import { Snowflake } from './snowflake.js';

export class Snowfall {
    constructor(canvas, options = {}) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.options = {
            snowflakeCount: options.snowflakeCount || 100,
            speed: options.speed || 1,
            wind: options.wind || 0,
            size: {
                min: options.size?.min || 2,
                max: options.size?.max || 5
            }
        };
        
        this.snowflakes = [];
        this.isAnimating = false;
        this.animationFrame = null;
        
        this.init();
        this.resize();
        
        // Bind resize event
        window.addEventListener('resize', () => this.resize());
    }
    
    init() {
        // Create initial snowflakes
        for (let i = 0; i < this.options.snowflakeCount; i++) {
            this.snowflakes.push(new Snowflake(this.canvas, this.options));
        }
    }
    
    resize() {
        // Make canvas full-screen
        this.canvas.width = this.canvas.offsetWidth;
        this.canvas.height = this.canvas.offsetHeight;
    }
    
    update() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        
        // Update and draw each snowflake
        this.snowflakes.forEach(snowflake => {
            snowflake.update();
            snowflake.draw(this.ctx);
        });
        
        if (this.isAnimating) {
            this.animationFrame = requestAnimationFrame(() => this.update());
        }
    }
    
    start() {
        if (!this.isAnimating) {
            this.isAnimating = true;
            this.update();
        }
    }
    
    stop() {
        this.isAnimating = false;
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
        }
    }
    
    setOptions(options) {
        this.options = { ...this.options, ...options };
        this.snowflakes.forEach(snowflake => snowflake.updateOptions(this.options));
    }
}
